import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

const PaymentFailurePage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#09090B] flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-[#121214] border border-[#27272A] rounded-lg p-8 text-center" data-testid="payment-failure-container">
        <XCircle className="mx-auto mb-4 text-[#EF4444]" size={64} />
        <h1 className="text-2xl font-heading font-bold mb-2">Payment Failed</h1>
        <p className="text-[#A1A1AA] mb-6">
          We couldn't process your payment. Please try again or contact support if the problem persists.
        </p>
        <div className="space-y-3">
          <Button
            onClick={() => navigate('/')}
            className="w-full bg-[#00F0FF] hover:bg-[#33F3FF] text-black rounded-full"
            data-testid="try-again-button"
          >
            Try Again
          </Button>
          <Button
            onClick={() => navigate('/')}
            variant="outline"
            className="w-full border-[#27272A] hover:bg-[#18181B] rounded-full"
          >
            Back to Store
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailurePage;
